import { render } from "./ThanksForOrderView.vue?vue&type=template&id=63b5c419&scoped=true"
import script from "./ThanksForOrderView.vue?vue&type=script&lang=js"
export * from "./ThanksForOrderView.vue?vue&type=script&lang=js"

import "./ThanksForOrderView.vue?vue&type=style&index=0&id=63b5c419&scoped=true&lang=css"

import exportComponent from "C:\\Users\\epentilescu\\source\\repos\\Delicitate V2\\front-end\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b5c419"]])

export default __exports__